import { placementById } from "./placements";

const HOME = [
  ["strip", 1, "hero_banners"],
  ["sections", 2, "square_primary"],
  ["restaurants", "Restaurants near you", "restaurants"],
  ["sections", 3, "square_secondary"],
  ["restaurants", "Pure Veg Restaurants", "pure_veg"],
  ["sections", 4, "square_tertiary"],
  ["restaurants", "Cakes & Bakery", "cake_stores"],
  ["strip", 5, "bottom_banner"],
];

const SURPLUS = [
  ["saleHero", 6, "hero"],
  ["sections", 7, "sections"],
];

const VIEW_ALL = { kind: "viewAll", placement: null, title: "View All Restaurants", rows: [], highlighted: false };

const shown = (kind, row) => {
  if (kind === "sections") return (row.banners || []).length > 0;
  if (kind === "restaurants") return !row.is_celebration_store;
  return true;
};

export const previewBlocks = (reply, screen, highlightPlacement) => {
  if (!reply) return [];
  const blocks = (screen === "surplus" ? SURPLUS : HOME)
    .map(([kind, placementOrTitle, key]) => {
      const placement = kind === "restaurants" ? null : placementOrTitle;
      return {
        kind,
        placement,
        title: placement ? placementById(placement).label : placementOrTitle,
        rows: (reply[key] || []).filter((row) => shown(kind, row)),
        highlighted: placement !== null && placement === Number(highlightPlacement),
      };
    })
    .filter((block) => block.kind === "saleHero" || block.rows.length > 0);
  return screen !== "surplus" && (reply.restaurants || []).length > 0 ? [...blocks, VIEW_ALL] : blocks;
};

export const mediaUrl = (path, host) => (!path ? "" : /^https?:\/\//.test(path) ? path : `${host}${path}`);
